import template from './flight-group-days-shift-arrival.html';

const DIRECTIVE_NAME = FlightGroupDaysShiftArrival.DIRECTIVE_NAME = 'ktFlightGroupDaysShiftArrival';
export default function FlightGroupDaysShiftArrival() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightGroupDaysShiftArrivalController,
        controllerAs: '$ctrl',
        scope: {
            group: `=${DIRECTIVE_NAME}`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightGroupDaysShiftArrivalController(
    $scope,
    flightGroupDaysShiftArrivalService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        $scope.$watch(() => vm.group, () => initDayShift());
    }

    function initDayShift() {
        const dayShift = getDayShift();
        vm.dayShift = dayShift ? `+${dayShift}` : '';
    }

    function getDayShift() {
        return flightGroupDaysShiftArrivalService.getDayShiftArrival(vm.group);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival-component.js